import React from 'react';
import { Plus, Mail, Shield, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  const handleCTAClick = () => {
    window.open('https://sistema.benmais.com/auto-contratacao?ref=MWZkYjg4ZDEtYzdiOC00ZTZiLWEzZDAtMGE5YjlkMjQ5ZTBhOmJiOGZmOTBiLWM5NjYtNDVmZi05MzAwLTUwNTkwMzhjYTczMQ==', '_blank');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511961475604?text=Olá! Gostaria de saber mais sobre o BEN+ALLCRED', '_blank');
  };

  return (
    <footer className="bg-[#0A1E2E] text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-white">Ben</span>
              <Plus className="w-7 h-7 text-[#00E5CC]" strokeWidth={3} />
              <span className="text-2xl font-bold text-white">ALLCRED</span>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Proteção completa e benefícios exclusivos para você e sua família por apenas R$ 59,90/mês.
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6">Contato</h3>
            
            {/* Email */}
            <a
              href="mailto:contato@allcredbeneficios.com.br"
              className="flex items-center gap-3 text-gray-300 hover:text-[#00E5CC] transition-colors group w-full"
            >
              <div className="w-10 h-10 bg-[#00E5CC]/20 rounded-lg flex items-center justify-center group-hover:bg-[#00E5CC]/30 transition-colors border border-[#00E5CC]/30">
                <Mail className="w-5 h-5 text-[#00E5CC]" />
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400">Email</div>
                <div className="font-semibold text-sm break-all">contato@allcredbeneficios.com.br</div>
              </div>
            </a>
            
            {/* WhatsApp */}
            <button
              onClick={handleWhatsAppClick}
              className="flex items-center gap-3 text-gray-300 hover:text-[#00E5CC] transition-colors group w-full"
            >
              <div className="w-10 h-10 bg-[#00E5CC]/20 rounded-lg flex items-center justify-center group-hover:bg-[#00E5CC]/30 transition-colors border border-[#00E5CC]/30">
                <Phone className="w-5 h-5 text-[#00E5CC]" />
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400">WhatsApp</div>
                <div className="font-semibold">(11) 96147-5604</div>
              </div>
            </button>

            {/* Endereço */}
            <div className="flex items-start gap-3 text-gray-300 mt-6">
              <div className="w-10 h-10 bg-[#00E5CC]/20 rounded-lg flex items-center justify-center border border-[#00E5CC]/30 flex-shrink-0">
                <MapPin className="w-5 h-5 text-[#00E5CC]" />
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400 mb-1">Endereço</div>
                <div className="font-medium text-sm">
                  Rua Major Mendonça, 1369<br />
                  Franca - SP<br />
                  CEP: 14401-161
                </div>
              </div>
            </div>

            {/* Contrate */}
            <button
              onClick={handleCTAClick}
              className="flex items-center gap-3 text-gray-300 hover:text-[#00E5CC] transition-colors group mt-4"
            >
              <div className="w-10 h-10 bg-[#00E5CC]/20 rounded-lg flex items-center justify-center group-hover:bg-[#00E5CC]/30 transition-colors border border-[#00E5CC]/30">
                <Plus className="w-5 h-5 text-[#00E5CC]" strokeWidth={3} />
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400">Contrate Agora</div>
                <div className="font-semibold">Sistema Ben+ALLCRED</div>
              </div>
            </button>
          </div>

          {/* Benefits Summary */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white mb-6">Benefícios</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
                Telemedicina 24h
              </li>
              <li className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
                Descontos em Farmácias
              </li>
              <li className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
                Indenizações
              </li>
              <li className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
                Assistência Residencial
              </li>
              <li className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
                Assistência Jurídica
              </li>
              <li className="flex items-center gap-2">
                <Plus className="w-4 h-4 text-[#00E5CC]" strokeWidth={3} />
                Auxílio Funeral
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#00E5CC]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Ben+ALLCRED. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Shield className="w-4 h-4 text-[#00E5CC]" />
              <span>Seus dados estão seguros conosco</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
